// EXTERNAL IMPORTS
import React, { Component } from "react";
import PropTypes from "prop-types";
import { themr } from "react-css-themr";
import classnames from "classnames";
import {
  Button,
  ButtonComposed,
  Link,
  modal,
  itemList,
  Select,
  Input,
} from "@lifepay/rc-ui-toolkit";

// ABSOLUTE PATH IMPORTS
import { ssoUser } from "model/gql/mutations";

// RELATIVE PATH IMPORTS
// importing default component styles
import styles from "./CreateUser.m.scss";

const CreateUser = itemList.MutationFactory(ssoUser.add);

@themr("@lifepay/CreateUser", styles)
export default class CardChangePinControl extends Component {
  // declaring props passed to the component
  static propTypes = {
    theme: PropTypes.object,
    onSuccess: PropTypes.func,
  };

  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      error: null,
      submitButtonState: "normal",
      roles: ["callcenter", "processing"],
      firstName: "",
      lastName: "",
      email: "",
    };
  }

  handleInput = ({ id, value }) => {
    this.setState({ [id]: value });
  };

  render() {
    const { theme, onSuccess } = this.props;
    const {
      loading,
      error,
      submitButtonState,
      email,
      roles,
      firstName,
      lastName,
    } = this.state;
    return (
      <modal.ModalController>
        {({ isOpen, close, open }) => {
          return (
            <React.Fragment>
              <div className={classnames(theme.control)}>
                <Button type={"alt"} size={"small"} onClick={open}>
                  {"Добавить пользователя"}
                </Button>
              </div>
              <modal.ModalBox
                isOpen={isOpen}
                close={() => (!loading ? close() : null)}
                theme={{
                  inner: theme.modal,
                }}
              >
                <CreateUser>
                  {(createUser, { data, dataState }) => {
                    const submit = (
                      <ButtonComposed
                        state={submitButtonState}
                        disabled={submitButtonState !== "normal"}
                        type={"main"}
                        size={"small"}
                        text={"Подтвердить"}
                        theme={{
                          wrapper: theme.button,
                        }}
                        onClick={() => {
                          this.setState({
                            loading: true,
                            submitButtonState: "loading",
                          });
                          createUser({
                            variables: {
                              username: email,
                              roles,
                              firstName,
                              lastName,
                              email,
                            },
                            update: (proxy, response) => {
                              this.setState({
                                loading: false,
                                submitButtonState: "normal",
                              });
                              onSuccess && onSuccess();
                              close();
                            },
                          }).catch((e) => {
                            this.setState({
                              loading: false,
                              error: e,
                              submitButtonState: "error",
                            });
                          });
                        }}
                      >
                        {"Создать"}
                      </ButtonComposed>
                    );

                    return (
                      <div className={classnames(theme["modal-content"])}>
                        <form
                          autoComplete="off"
                          className={classnames(theme.form)}
                        >
                          <div className={classnames(theme.inputs)}>
                            <div
                              className={classnames(theme.summary)}
                            >{`Создать пользователя`}</div>
                            <Input
                              id={"email"}
                              type={"email"}
                              value={email}
                              inputProps={{
                                name: "new",
                                autoComplete: "off",
                              }}
                              controlled
                              onChange={this.handleInput}
                            >
                              {"Email"}
                            </Input>
                            <Select
                              id={"roles"}
                              value={roles}
                              multiple
                              hideChooseAll
                              options={[
                                { value: "callcenter", label: "Коллцентр" },
                                { value: "processing", label: "Процессинг" },
                                { value: "serviceDesk", label: "Сервисдеск" },
                              ]}
                              onChange={this.handleInput}
                            >
                              {"Роли пользователя"}
                            </Select>
                            <Input
                              id={"firstName"}
                              inputProps={{
                                name: "firstName",
                                autoComplete: "none",
                              }}
                              value={firstName}
                              controlled
                              onChange={this.handleInput}
                            >
                              {"Имя"}
                            </Input>
                            <Input
                              id={"lastName"}
                              inputProps={{
                                name: "last-name",
                                autoComplete: "none",
                              }}
                              value={lastName}
                              controlled
                              onChange={this.handleInput}
                            >
                              {"Фамилия"}
                            </Input>
                            {error ? (
                              <React.Fragment>
                                <div className={classnames(theme.summary)}>
                                  {error.message}
                                </div>
                                <div className={classnames(theme.summary)}>
                                  <Link
                                    type={"negative"}
                                    withRouter={false}
                                    onClick={() => {
                                      this.setState({
                                        error: null,
                                        submitButtonState: "normal",
                                      });
                                    }}
                                  >
                                    {"Очистить ошибку"}
                                  </Link>
                                </div>
                              </React.Fragment>
                            ) : null}
                          </div>
                          <div className={classnames(theme.submit)}>
                            {email.length ? submit : null}
                            <Button
                              type={loading ? "disabled" : "alt"}
                              size={"small"}
                              disabled={loading}
                              theme={{
                                wrapper: theme.button,
                              }}
                              onClick={() => {
                                close();
                              }}
                            >
                              {"Отмена"}
                            </Button>
                          </div>
                        </form>
                      </div>
                    );
                  }}
                </CreateUser>
              </modal.ModalBox>
            </React.Fragment>
          );
        }}
      </modal.ModalController>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Private/pages/workflow-admin/Users/CreateUser/CreateUser.js